import { useEffect } from "react"
import useSound from "use-sound"
import jackpotBackgroundSFX from "../lib/audio/Jackpot-Background-Music.mp3"

export const handleJackpotBackgroundSFX = (
  isMusicOff: any,
  music: any,
  isError: any,
  isLoading: any,
  jackpotState: any,
  disableMusic: any,
  errorText: any,
) => {
  const [playJackpotBackgroundSFX, { stop, sound: bgSound }] = useSound(
    jackpotBackgroundSFX,
    {
      volume: parseFloat(music) / 100,
    },
  )

  useEffect(() => {
    if (errorText !== "") {
      stop()
    }
  }, [errorText])

  useEffect(() => {
    !isMusicOff &&
      !isError &&
      !isLoading &&
      !disableMusic &&
      (jackpotState === "initRound" || jackpotState === "roundStarted")
      ? (() => {
        playJackpotBackgroundSFX()
        bgSound && bgSound.loop(true)
      })()
      : stop()

  }, [
    isMusicOff,
    playJackpotBackgroundSFX,
    stop,
    isError,
    isLoading,
    jackpotState,
    disableMusic,
  ])
}
